package hk.com.vr360_demo2.webapp.core.net.common

import kotlinx.serialization.Serializable

@Serializable
data class ResponseInfo<T>(
    var extra: String? = null,
    var data: T? = null,
    var code: Int = 0,
    var msg: String? = null,
    var currentPage: Int = 0,
    var pageSize: Int = 0,
    var count: Int = 0,
    var pageCount: Int = 0,
    var token: String? = null,
//    var extraData: HashMap<String, Int?>? = null,
    var tag: String? = null
) {
    fun isSuccess(): Boolean {
        return code == 200
    }

    fun allLoaded(): Boolean {//是否已經全部加載完畢
        return currentPage >= pageCount
    }
    fun canLoadMore():Boolean{
        return pageCount > currentPage
    }

    //    var extra: String? = null

    companion object {
        fun <T>  error(error: String): ResponseInfo<T> {
            return ResponseInfo<T>().apply {
                msg = error
                code = 500
            }
        }

        fun <T> success(data: T): ResponseInfo<T> {
            return ResponseInfo(data = data, code = 200)
        }

    }

}
